
import { listBrands } from "@/graphql/queries";
import { Brand } from "@/types/AppTypes";
import { createQueryOptions } from "../shared/createQueryOptions";
import { fetchAllPaginatedGraphQl } from "../shared/fetchAllPaginatedGraphQl";

interface BrandFilter {
  [key: string]: any;
}

export const fetchAllBrands = async (filter: BrandFilter = {}): Promise<Brand[]> => {
  return fetchAllPaginatedGraphQl<Brand>(listBrands, { filter });
};

export const fetchAllBrandsQueryOptions = (
  filter: BrandFilter = {},
  options = {}
) =>
  createQueryOptions<Brand>({
    queryKey: ["brands", filter],
    graphqlQuery: listBrands,
    getVariables: () => ({ 
        ...filter,
        is_deleted: {
            eq: false,
        },
        is_active: {
            eq: true,
        },
    }),
    options: {
      select: (data: Brand[]) => {
        return data.sort((a: Brand, b: Brand) => (a.name || '').localeCompare(b.name || ''));
      },
      ...options,
    },
  });
